import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, LoginError } from '../services/api';
import '../styles/login.css';

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [remainingAttempts, setRemainingAttempts] = useState<number | null>(null);
  const [isLockedOut, setIsLockedOut] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setRemainingAttempts(null);
    setIsLockedOut(false);
    setIsLoading(true);

    try {
      const response = await login(username, password);
      
      // Store employee data and token
      localStorage.setItem('loggedInEmployee', JSON.stringify({
        id: response.employee.id,
        name: response.employee.name,
        username: response.employee.username,
        initials: response.employee.initials,
        color: response.employee.color,
        profilePic: response.employee.profilePic,
        bio: response.employee.bio,
        title: response.employee.title,
        address: response.employee.address,
        phone: response.employee.phone,
        email: response.employee.email,
        website: response.employee.website
      }));
      
      localStorage.setItem('authToken', response.token);
      
      navigate('/dashboard');
    } catch (err) {
      console.error('Login error caught:', err);
      const loginError = err as LoginError;
      const errorMessage = loginError.error || 'Er is een onbekende fout opgetreden';
      console.error('Setting error message:', errorMessage);
      setError(errorMessage);
      setRemainingAttempts(loginError.remainingAttempts);
      setIsLockedOut(loginError.lockedOut || false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img 
            src="/Logo.png" 
            alt="Dashboard Logo"
            className="login-logo"
          />
          <h1>Dashboard Login</h1>
          <p>Log in met je medewerker account</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">Gebruikersnaam</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Voer je gebruikersnaam in"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Wachtwoord</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Voer je wachtwoord in"
              required
            />
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Inloggen...' : 'Inloggen'}
          </button>
        </form>

        {error && remainingAttempts !== null && !isLockedOut && remainingAttempts < 5 && (
          <div className="attempts-counter">
            Nog {remainingAttempts} {remainingAttempts === 1 ? 'poging' : 'pogingen'} voor blokkade
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
